import { ARBUZ_RUNE } from '../config/constants'
import { useAddressAlkanes } from './useAddressAlkanes'

// output.value === 0 means mempool.space no longer lists the outpoint as a UTXO -
// it is already spent (e.g. burned by a card mint, possibly from another device)
// while the alkanode indexer still lags behind and returns it. Hide it everywhere:
// holdings trays, credit counters and pickers must not show burned Arbuz.
const isUnspent = (token) => token.output?.value > 0

export function useWalletTokens() {
  const { data, isLoading, isFetching, error, refetch } = useAddressAlkanes()

  const outpoints = data?.outpoints || []
  const isArbuzToken = (token) =>
    token.balance_sheet?.cached?.balances?.some(
      b => b.block === ARBUZ_RUNE.BLOCK && b.tx === ARBUZ_RUNE.TX
    ) ?? false

  const tokens = outpoints.filter(tk => isArbuzToken(tk) && isUnspent(tk))

  return {
    tokens,
    loading: isLoading,
    fetching: isFetching,
    error: error?.message || null,
    hasArbuz: tokens.length > 0,
    refetch,
  }
}

export function useAllTokens() {
  const { data, isLoading, isFetching, error, refetch } = useAddressAlkanes()

  const tokens = (data?.outpoints || []).filter(token =>
    token.balance_sheet?.cached?.balances?.length > 0 && isUnspent(token)
  )

  return {
    tokens,
    loading: isLoading,
    fetching: isFetching,
    error: error?.message || null,
    refetch,
  }
}
